import { Box } from "@mui/material"
import { CheckboxComponent } from "../../../inputComponents/CheckboxComponent"
import { InputNumberSpinner } from "../../../inputComponents/InputNumberSpinner"
import TooltipText from "../../../inputComponents/TooltipText"
import { FormikProps } from "formik"

interface CurrencyValidityProps {
    formik: FormikProps<any>;
    isEdit: boolean;
    contentBoxClass?: string;
}

const CurrencyValidity = ({ formik, isEdit, contentBoxClass }: CurrencyValidityProps) => {

    const handleUncheckedValidity = (event: any) => {
        const checked = event.target.checked;
        if (!checked) {
            formik.setFieldValue('configurationParameters.validity', {});
            formik.setFieldValue('tempParams.validityDays', 1);
        }
    };

    return (
        <Box className={contentBoxClass || 'functionality-items'}>
            <CheckboxComponent
                customBoxClass='currencies-checkbox'
                fieldName={'tempParams.currencyValidity'}
                label={
                    <TooltipText
                        text={'Currency Validity (Optional)'}
                        textVariant='body1'
                        tooltip='Enable this option if you want to set a period of validity for all currencies selected for this promotion. The minimum period is 1 day'
                        styleName={'validity-checkbox-tooltip'}
                    />
                }
                disabledCondition={
                    !formik.values.tempParams.currencyNames ||
                    !formik.values.tempParams.currencyNames.filter((name: string) => name !== '').length
                }
                customAction={handleUncheckedValidity}
            />
            {formik.values.tempParams.currencyValidity && (
                <InputNumberSpinner
                    fieldName={'tempParams.validityDays'}
                    label={'Select Number of Days'}
                    incrementValue={1}
                    customClass={'currency-spinner-input'}
                    inputClass={'currency-spinner-input'}
                    minValue={1}
                />
            )}
            {isEdit && (
                <CheckboxComponent
                    fieldName={'tempParams.totalCurrencyAccumulated'}
                    label='Show Total Accumulated Per Currency'
                    labelVariant='body1'
                    customBoxClass='accumulated-currencies-checkbox'
                ></CheckboxComponent>
            )}
        </Box>
    )
}

export { CurrencyValidity}